import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SelectModule } from '@cmps/ng-select';
import {
    CmpsButtonModule,
    CmpsDialogModule,
    CmpsIconModule,
    CmpsSelectModule,
    CmpsTooltipModule,
} from '@cmps/ng-uikit';
import { TranslateModule } from '@ngx-translate/core';

import { CmpsCommonModule } from '../../../../common/common.module';
import { CmpsBgGradientModule } from '../../../../common/pipe/bg-gradient';
import { CmpsLazyI18nModule } from '../../../../i18n/i18n.module';
import { CmpsCoachingUserProfileModule } from '../../../user-profile';
import { ExperimentalNgGridModule } from '../grid';
import { WpNumberPipe } from '../pipe/wp-number.pipe';
import { WpPercentPipe } from '../pipe/wp-percent.pipe';

import { CommitmentDetailsDialogComponent } from './component/commitment-details-dialog/commitment-details-dialog.component';
import { TranslationIdMap as CommitmentDetailsDialogTranslationIdMap } from './component/commitment-details-dialog/commitment-details-dialog.component.i18n';
import { InfoDialogComponent } from './component/info-dialog/info-dialog.component';
import { TranslationIdMap as InfoDialogTranslationIdMap } from './component/info-dialog/info-dialog.component.i18n';
import { PercentageComponent } from './component/percentage/percentage.component';
import { TranslationIdMap as PercentageTranslationIdMap } from './component/percentage/percentage.component.i18n';
import { ProgressBarComponent } from './component/progress-bar/progress-bar.component';
import { TranslationIdMap as ProgressBarTranslationIdMap } from './component/progress-bar/progress-bar.component.i18n';
import { MainComponent } from './main.component';
import { TranslationIdMap as MainTranslationIdMap } from './main.i18n';

@NgModule({
    declarations: [
        CommitmentDetailsDialogComponent,
        InfoDialogComponent,
        MainComponent,
        PercentageComponent,
        ProgressBarComponent,
        WpNumberPipe,
        WpPercentPipe,
    ],
    exports: [MainComponent],
    imports: [
        CmpsBgGradientModule,
        CmpsButtonModule,
        CmpsCoachingUserProfileModule,
        CmpsCommonModule,
        CmpsDialogModule,
        CmpsIconModule,
        CmpsLazyI18nModule.forChild(CommitmentDetailsDialogTranslationIdMap),
        CmpsLazyI18nModule.forChild(InfoDialogTranslationIdMap),
        CmpsLazyI18nModule.forChild(MainTranslationIdMap),
        CmpsLazyI18nModule.forChild(PercentageTranslationIdMap),
        CmpsLazyI18nModule.forChild(ProgressBarTranslationIdMap),
        CmpsSelectModule,
        CmpsTooltipModule,
        CommonModule,
        ExperimentalNgGridModule,
        FormsModule,
        SelectModule,
        TranslateModule,
    ],
})
export class CmpsCoachingWpMainModule {}
